<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-card>
      <v-card-text class="pa-5">
        <v-row>
          <v-col>
            <h1>Создание отзыва</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <review-form
              :errors="errors"
              @onSubmit="submit"
            />
          </v-col>
        </v-row>
        <v-snackbar
          v-model="snackbarSuccess"
          :timeout="timeout"
          color="success"
        >
          Сохранено

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              @click="snackbarSuccess = false"
              color="red"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        <v-snackbar
          v-model="snackbarError"
          :timeout="timeout"
          color="error"
        >
          {{ this.errors }}

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              @click="snackbarError = false"
              color="red"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {Review} from "../../../models/review";
import ReviewForm from "../../../components/reviews/ReviewForm";

export default {
  name: 'Create',
  components: {ReviewForm},
  data: () => ({
    errors: {},
    snackbarSuccess: false,
    snackbarError: false,
    timeout: 2000,
    page: {
      title: "Создание отзывы"
    },
    breadcrumbs: [
      {
        text: "Админ панель",
        disabled: false,
        to: '/'
      },
      {
        text: "Отзывы",
        disabled: true,
        to: '/reviews'
      },
      {
        text: "Создание",
        disabled: true,
        to: '/reviews/create'
      },
    ],
  }),
  methods: {
    async submit({form, isNeedRedirect}) {
      try {
        this.errors = {};
        const review = await Review.$query().store(form);
        this.snackbarSuccess = true;

        if (isNeedRedirect) {
          await this.$router.push({name: 'reviews-index'});
        } else {
          await this.$router.push({ name: 'reviews-edit', params: { id: review.$attributes.id } });
        }
      } catch (e) {
        if (e.response?.data) {
          this.errors = e.response.data.errors
          this.snackbarError = true;
        }
        throw e;
      }
    },
  },
};
</script>
